/**
 * Auth Storage Manager
 */

import type { User } from './types';

export class AuthStorage {
  private tokenKey: string;
  private userKey: string;

  constructor(prefix = 'iampam_auth') {
    this.tokenKey = `${prefix}_token`;
    this.userKey = `${prefix}_user`;
  }

  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  setUser(user: User): void {
    localStorage.setItem(this.userKey, JSON.stringify(user));
  }

  getUser(): User | null {
    const data = localStorage.getItem(this.userKey);
    if (!data) return null;
    try {
      return JSON.parse(data) as User;
    } catch {
      return null;
    }
  }

  clear(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userKey);
  }

  hasAuth(): boolean {
    return !!this.getToken() && !!this.getUser();
  }
}
